import { request } from '../../helpers/api/request';

export const deleteFeed = async (id: number) => {
    const { data } = await request({
        url: `admin/feeds/${id}`,
        method: 'DELETE',
    });

    return data;
};
